/**
 * LicenseBuilderButton Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { ILicenseBuilderPortalProps, LicenseBuilderPortal } from '../../../organisms/forms/LicenseBuilder/portal';
import { LicensePresetsMenuPortal } from '../../../organisms/forms/LicensePresetsMenu';
import Button, { ButtonProps } from '../Button';

interface IOwnProps extends ButtonProps, Omit<ILicenseBuilderPortalProps, 'onClose'> {
  stopPropagation?: boolean;
  onOpenLicenseBuilder?: () => any;
  onCloseLicenseBuilder?: () => any;
}

export type LicenseBuilderButtonProps = IOwnProps;

interface IOwnState {
  licenseBuilderIsActive: boolean;
  showLicenseBuilder: boolean;
}

const classes = new BEM('license-builder-button');

export default class LicenseBuilderButton extends React.Component<LicenseBuilderButtonProps, IOwnState> {

  isComponentMounted = false;

  state = {
    licenseBuilderIsActive: false,
    showLicenseBuilder: false,
  };

  componentDidMount() {
    this.isComponentMounted = true;
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  onClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    if (this.props.stopPropagation) {
      e.stopPropagation();
    }

    if (!!this.props.onClick) {
      e.persist();
      this.props.onClick(e);
    }

    this.setState({ licenseBuilderIsActive: true });
    if (this.props.onOpenLicenseBuilder) {
      this.props.onOpenLicenseBuilder();
    }
  }

  onCloseLicenseBuilder = () => {
    if (this.isComponentMounted) {
      this.setState({ licenseBuilderIsActive: false, showLicenseBuilder: false });
      if (this.props.onCloseLicenseBuilder) {
        this.props.onCloseLicenseBuilder();
      }
    }
  }

  onSelectPreset = (usage: ILicenseUsage) => {
    this.props.onSaveLicense([usage]);
  }

  openLicenseBuilder = () => {
    this.setState({
      showLicenseBuilder: true,
    });
  }

  render() {
    const {
      className,
      onClick: unusedOnClick,
      onSaveLicense,
      scope,
      selectedUsage,
      stopPropagation,
      usages,
      onOpenLicenseBuilder,
      onCloseLicenseBuilder,
      ...buttonProps
    } = this.props;

    const hasLicense = !!usages && (usages.length > 0);

    return (
      <>
        <Button
          onClick={this.onClick}
          title="Build your license to display prices."
          {...classes('', '', className)}
          {...buttonProps}
        />
        {this.state.licenseBuilderIsActive && !hasLicense && !this.state.showLicenseBuilder && (
          <LicensePresetsMenuPortal
            onClose={this.onCloseLicenseBuilder}
            onSelectPreset={this.onSelectPreset}
            onOpenLicenseBuilder={this.openLicenseBuilder}
          />
        )}
        {this.state.licenseBuilderIsActive && (hasLicense || this.state.showLicenseBuilder) && (
          <LicenseBuilderPortal
            scope={scope}
            selectedUsage={selectedUsage}
            usages={usages}
            onSaveLicense={onSaveLicense}
            onClose={this.onCloseLicenseBuilder}
          />
        )}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/LicenseBuilderButton/index.tsx